import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MaxWidthFormattedTextField } from 'cxid-common-components/util-components'
import { validateDob, updateDob, postForm, trackDobInput } from '../store/actions'

class Dob extends PureComponent {
  render() {
    const { dob, dobError, dispatchValidateDob, dispatchUpdateDob } = this.props

    return (
      <MaxWidthFormattedTextField
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
        error={dobError || dobError.length > 0}
        format="date"
        fullWidth
        id="dob"
        inputRef={input => {
          this.dob = input
        }}
        label="Birthdate"
        message={
          // eslint-disable-next-line no-nested-ternary
          dob && dob.length > 0 ? (dobError || dobError.length > 0 ? dobError : 'MM/DD/YYYY') : ''
        }
        onBlur={dispatchValidateDob}
        onChange={dispatchUpdateDob}
        value={dob}
      />
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchPostForm: postForm,
      dispatchValidateDob: validateDob,
      dispatchUpdateDob: updateDob,
      dispatchTrackDobInput: trackDobInput
    },
    dispatch
  )

const mapStateToProps = state => ({
  dob: state.form.dob,
  dobValid: state.form.dobValid,
  dobError: state.form.dobError
})

export default connect(mapStateToProps, mapDispatchToProps)(Dob)
